import React from 'react';

const DateNasa = ({photoData}) => {
  return (
    <div> 
      <p>{photoData}</p>
    </div>
  )
}

export default DateNasa